window.bundleDataO = {
"Oliver-boy": {
displayName: "Oliver",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Oliver Personalized Coloring Experience",
variantId: "49279571624173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oliver_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "Oliver Dragon Holographic Sticker",
variantId: "49933774160109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oliver_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Oliver Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Olivia-girl": {
displayName: "Olivia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Olivia Personalized Coloring Experience",
variantId: "49607265747181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Olivia_final_cover.png?v=1773443857",
price: "$14.99",
preorder: true
},
{
title: "Olivia Unicorn Holographic Sticker",
variantId: "49933756236013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Olivia_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Olivia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Omar-boy": {
displayName: "Omar",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Omar Personalized Coloring Experience",
variantId: "49411966664941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/OMAR_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Omar Dragon Holographic Sticker",
variantId: "49933767311597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Omar_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Omar Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Opal-girl": {
displayName: "Opal",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Opal Personalized Coloring Experience",
variantId: "49274308657389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Opal_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Opal Unicorn Holographic Sticker",
variantId: "49933780877549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Opal_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Opal Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ophelia-girl": {
displayName: "Ophelia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ophelia Personalized Coloring Experience",
variantId: "49929701392621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ophelia_final_cover.png?v=1777863212",
price: "$14.99",
preorder: true
},
{
title: "Ophelia Unicorn Holographic Sticker",
variantId: "49933745553645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ophelia_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Ophelia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Orion-boy": {
displayName: "Orion",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Orion Personalized Coloring Experience",
variantId: "49731766681837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Orion_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Orion Dragon Holographic Sticker",
variantId: "49933753680109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Orion_holographic_sticker.png?v=1780106108",
price: "$4.99",
preorder: false
},
{
title: "Orion Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Oscar-boy": {
displayName: "Oscar",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Oscar Personalized Coloring Experience",
variantId: "49411967287533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/OSCAR_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Oscar Dragon Holographic Sticker",
variantId: "49933767278829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oscar_holographic_sticker.png?v=1780106106",
price: "$4.99",
preorder: false
},
{
title: "Oscar Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ottilie-girl": {
displayName: "Ottilie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ottilie Personalized Coloring Experience",
variantId: "49339277672685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ottilie_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Ottilie Unicorn Holographic Sticker",
variantId: "49933772521709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ottilie_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Ottilie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Owen-boy": {
displayName: "Owen",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Owen Personalized Coloring Experience",
variantId: "49265130438893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Owenfinalcover.png?v=1772678511",
price: "$14.99",
preorder: true
},
{
title: "Owen Dragon Holographic Sticker",
variantId: "49933781467373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Owen_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Owen Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Olive-girl": {
displayName: "Olive",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Olive Personalized Coloring Experience",
variantId: "50274185117933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Olive_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Olive Unicorn Holographic Sticker",
variantId: "50274693087469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oliveholographicsticker.png?v=1783828891",
price: "$4.99",
preorder: false
},
{
title: "Olive Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Oakley-girl": {
displayName: "Oakley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Oakley Personalized Coloring Experience",
variantId: "50305376911597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oakleyfinalcover.png?v=1784421833",
price: "$14.99",
preorder: true
},
{
title: "Oakley Unicorn Holographic Sticker",
variantId: "50305508901101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oakley_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Oakley Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Oaklynn-girl": {
displayName: "Oaklynn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Oaklynn Personalized Coloring Experience",
variantId: "50305377468653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oaklynnfinalcover.png?v=1784422149",
price: "$14.99",
preorder: true
},
{
title: "Oaklynn Unicorn Holographic Sticker",
variantId: "50305510244589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Oaklynn_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Oaklynn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 



};